import React from 'react'
import ReactDOM from 'react-dom'
import './css/index.css'
import axios from 'axios'
import App from './App'
import reportWebVitals from './reportWebVitals'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

axios.defaults.withCredentials = true

ReactDOM.render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

serviceWorkerRegistration.register()
